import { Icon } from "@msuite/ui/icons";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta } from "@msuite/ui/table";
import { TransactionTypeTag } from "@msuite/ui/tag";
import { cn } from "@msuite/ui/utils";
import { createdAtFormatter } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import { getOrderNumberString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import type { LoadCarrierTransactionListItem } from "@msuite/utils/types";

const columnHelper = createColumnHelper<LoadCarrierTransactionListItem>();

export const columns = [
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		meta: createMeta({ isTabular: true }),
	}),
	columnHelper.accessor("operation", {
		id: "operation",
		header: localized("stock.operations.operation"),
	}),
	columnHelper.accessor("quantity", {
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => {
			const isAdd = cell.row.original.operation === "ADD";
			return (
				<div className={cn("h-stack justify-end", isAdd ? "text-emerald-600" : "text-red-600")}>
					<Icon name={isAdd ? "Plus" : "Minus"} />
					<span>{formatNumber(cell.getValue(), "integer").toString().padStart(8, " ")}</span>
				</div>
			);
		},
		meta: createMeta({ isNumeric: true }),
	}),
	columnHelper.accessor("userName", {
		id: "createdBy",
		header: localized("general_fields.created_by"),
	}),
	// The order a movement shipped on, where a picking round is what moved it. A hand-booked
	// arrival, return or yard correction belongs to no order and reads as the fallback — which is
	// most of a healthy ledger.
	columnHelper.accessor("orderNumber", {
		id: "orderNumber",
		header: localized("stock.order_no"),
		cell: (cell) => (cell.getValue() ? getOrderNumberString(cell.getValue()) : "--"),
		meta: createMeta({ isTabular: true }),
	}),
	columnHelper.accessor("warehouseZoneName", {
		id: "warehouseZoneName",
		header: localized("stock.warehouse_zone"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("type", {
		id: "type",
		cell: (cell) => <TransactionTypeTag type={cell.getValue()} />,
	}),
];
